import React from "react";
import heroImg from "../Assests/Image6.jpg";
import mapImg from "../Assests/Image3.jpg";
import teamImg from "../Assests/Image5.jpg";

function Contact() {
  return (
    <div className="page">
      <section className="page-hero" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="page-hero__content">
          <p className="eyebrow">Let's talk</p>
          <h1>Talk to our sales and logistics teams</h1>
          <p>
            Tell us what you need - retail packs, bulk orders, or private-label blends. We respond within one business
            day.
          </p>
          <div className="chip-row">
            <span className="chip">Samples available</span>
            <span className="chip">Private label</span>
            <span className="chip">Bulk & export</span>
          </div>
        </div>
      </section>

      <section className="section contact-grid">
        <div className="card emphasis-card">
          <h3>Visit & call</h3>
          <ul className="contact-list">
            <li>
              <strong>Address:</strong> Kurunegala, North Western Province, Sri Lanka
            </li>
            <li>
              <strong>Hotline:</strong> <a href="tel:+94771234567">+94 77 123 4567</a>
            </li>
            <li>
              <strong>Office:</strong> <a href="tel:+94372222333">+94 37 222 2333</a>
            </li>
            <li>
              <strong>Email:</strong> <a href="mailto:hello@rajaratarice.lk">hello@rajaratarice.lk</a>
            </li>
            <li>
              <strong>Hours:</strong> Mon - Sat, 8:00 AM - 6:00 PM
            </li>
          </ul>
          <div className="ribbon" style={{ marginTop: 12 }}>
            <strong>Urgent shipment?</strong>
            <span>Call the hotline and we will fast-track your dispatch.</span>
          </div>
        </div>
        <div className="card emphasis-card">
          <h3>Request a quotation</h3>
          <p>Share your requirements and we will confirm pricing, lead times, and sample availability.</p>
          <form className="contact-form">
            <label>
              Name
              <input type="text" placeholder="Your full name" />
            </label>
            <label>
              Company
              <input type="text" placeholder="Hotel, supermarket, distributor, etc." />
            </label>
            <label>
              Email
              <input type="email" placeholder="you@example.com" />
            </label>
            <label>
              Requirements
              <textarea rows="3" placeholder="Product type, pack size, monthly volume"></textarea>
            </label>
            <button type="button" className="btn btn--primary">
              Send enquiry
            </button>
          </form>
          <p className="muted">We respond within one business day. For urgent orders, please call the hotline.</p>
        </div>
        <div className="media-blend">
          <img src={mapImg} alt="Serving Sri Lanka with reliable logistics" />
          <div className="media-blend__text">Island-wide delivery and export assistance</div>
        </div>
        <div className="media-blend">
          <img src={teamImg} alt="Team at the packing line" />
          <div className="media-blend__text">Dedicated account managers for every client</div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
